'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = enforceDecorator;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function field(fieldName, decorator) {
  (0, _invariant2.default)(typeof decorator[fieldName] === 'function', 'expected `decorator.%s` to be a function but got `%s`', fieldName, decorator[fieldName]);
}

function optionalField(fieldName, decorator) {
  (0, _invariant2.default)(!decorator[fieldName] || typeof decorator[fieldName] === 'function', 'expected `decorator.%s` to be an optional function but got `%s`', fieldName, decorator[fieldName]);
}

function enforceDecorator(decorator) {
  field('displayName', decorator);
  optionalField('defaultProps', decorator);
  optionalField('initialState', decorator);
  optionalField('propTypes', decorator);
  field('nextProps', decorator);
  return decorator;
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-decorate/lib/enforceDecorator.js
 ** module id = 722
 ** module chunks = 0
 **/